import { Metadata } from 'next';

export const getPageTitle = (titleText: string) => titleText;

export const prepareMetadata = (
  titleText = 'Zero Trust for People and AI Agents',
  description = 'Primary governs what your people and AI agents can see, decide, and do. Zero Trust policy enforcement, continuous identity verification, and real-time visibility in one control plane built for the modern enterprise.',
  keywords: string[] = [],
  secondaryKeywords: string[] = []
): Metadata => {
  const title = getPageTitle(titleText);
  const url = 'https://primary.ai/';
  const ogDescription = 'Primary governs what your people and AI agents can see, decide, and do. Zero Trust policy. Unified identity. Real-time visibility.'
  const allKeywords = [...keywords, ...secondaryKeywords];
  // Social-share banner (public/og-banner-v2.webp). Applied to every page that
  // uses prepareMetadata via the openGraph/twitter blocks below.
  const ogImage = {
    url: '/og-banner-v2.webp',
    width: 1200,
    height: 630,
    alt: 'Primary — Unified Zero Trust Control Plane',
  };

  return {
    title,
    description,
    ...(allKeywords.length > 0 && { keywords: allKeywords }),
    robots: {
      index: true,
      follow: true,
      nocache: true,
      googleBot: {
        index: true,
        follow: true,
        noimageindex: true,
        'max-video-preview': -1,
        'max-image-preview': 'large',
        'max-snippet': -1,
      },
    },
    openGraph: {
      title,
      description: ogDescription,
      url,
      siteName: 'Primary',
      images: [ogImage],
      locale: 'en_US',
      type: 'website',
    },
    twitter: {
      card: 'summary_large_image',
      title,
      description,
      images: [ogImage],
    },
  };
};
